import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-require-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
})
export class EmailVerificationComponent  implements OnInit {
  contact = new CustomerContact()

  form = new FormGroup({
    code: new FormControl('')
  })

  constructor(
    private customerService: CustomerService,
    private activeModal: NgbActiveModal,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle($localize`Verify your email address`)

    this.customerService.current().subscribe({
      next: (contact) => {
        this.contact = contact
      }
    })
  }

  save() {
    this.customerService.verifyEmail(this.form.controls.code.value as string).subscribe({
      next: () => {
        this.customerService.ping().subscribe({
          next: () => this.activeModal.close(),
          error: () => this.activeModal.close()
        })
      }
    })
  }

  resend() {
    this.customerService.resendEmailVerification().subscribe({
      next: () => {
        alert($localize `Verification code resent`)
      },
    })
  }
}
